const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
/**
 * @constructor
 *
 * @param {CurrentDevice} currentDevice
 * @param {UserService} userService
 */
const PaymentMethodService = function (
    currentDevice,
    userService
) {
    this.currentDevice = currentDevice;
    this.userService = userService;
};

PaymentMethodService.prototype = {
    /**
     * Return all available payment method for the current company / device.
     *
     * @return {PaymentMethod[]}
     */
    getAll() {
        if (!this.userService || !this.userService.company || !this.userService.company.companyPaymentMethods) {
            return [];
        }

        let paymentMethods = this.userService.company.companyPaymentMethods;

        if (this.currentDevice && this.currentDevice.device && this.currentDevice.device.disabledPaymentMethodIDs) {
            // Remove payment methods disabled for this device.
            paymentMethods = paymentMethods.filter(
                (pm) => this.currentDevice.device.disabledPaymentMethodIDs.indexOf(pm.ID) === -1
            );
        }

        // Don't show payment methods we don't support yet in ProPoint even if they exist in the database.
        // This prevents broken templates in development when switching branches.
        paymentMethods = paymentMethods.filter(
            (pm) => Object.values(PaymentMethodRef).includes(pm.ref)
        );

        return paymentMethods;
    },

    /**
     * @param {string} ref
     * @return {?PaymentMethod}
     */
    getByRef(ref) {
        return this.getAll().find((pm) => pm.ref === ref);
    },

    /**
     * @returns {?PaymentMethod}
     */
    getCashPaymentMethod() {
        return this.getByRef(PaymentMethodRef.CASH);
    },

    /**
     * @returns {boolean}
     */
    methodsAreAvailable() {
        return !!this.getAll().length;
    },

    /**
     * @return {boolean}
     */
    refundMethodsAreAvailable() {
        return !!this.getAll().find((pm) => pm.supportsNegativePaymentInProPoint);
    },
};

module.exports = PaymentMethodService;
